import { nextTick as m } from "vue";
const p = {
  position: "absolute",
  top: 0,
  left: 0,
  visibility: "hidden",
  height: 0,
  overflow: "scroll",
  whiteSpace: "pre"
};
function f(t, n) {
  return typeof t == "string" ? t : t ? `${t}px` : n;
}
function u(t, n) {
  const { fontSize: i, fontFamily: e, fontWeight: r, fontStyle: s, letterSpacing: d, textTransform: c, minWidth: a, maxWidth: o } = t;
  Object.assign(n.style, {
    ...p,
    fontSize: i,
    fontFamily: e,
    fontWeight: r,
    fontStyle: s,
    letterSpacing: d,
    textTransform: c,
    minWidth: a,
    maxWidth: o
  });
}
function h(t, { value: n }) {
  const i = {
    extraWidth: 16,
    ...n
  };
  let e = t.instance.value;
  e || (e = t.instance.placeholder || ""), t.mirror.innerText = e;
  const r = t.mirror.getBoundingClientRect().width + i.extraWidth + 2;
  if (t.children.length > 2) {
    t.instance.style.setProperty("--p-input-width", `${r}px`);
    return;
  }
  t.style.setProperty("--p-input-width", `${r}px`);
}
function y(t, { value: n }) {
  if (n && (t.instance = t, t.tagName.toLocaleUpperCase() !== "INPUT")) {
    const i = t.querySelector("input");
    if (!i)
      return;
    t.instance = i;
  }
}
async function W(t, { value: n }) {
  if (!n)
    return;
  await m(), t.mirror = document.createElement("span");
  const i = window.getComputedStyle(t.instance), { fontSize: e, fontFamily: r, fontWeight: s, fontStyle: d, letterSpacing: c, textTransform: a } = i, o = {
    fontSize: e,
    fontFamily: r,
    fontWeight: s,
    fontStyle: d,
    letterSpacing: c,
    textTransform: a,
    maxWidth: f(n.maxWidth, "960px"),
    minWidth: f(n.minWidth, 0)
  };
  t.instance.style.maxWidth = o.maxWidth, t.instance.style.minWidth = o.minWidth, t.style.minWidth = o.minWidth, t.style.maxWidth = o.maxWidth, u(o, t.mirror), t.appendChild(t.mirror), h(t, { value: n });
}
function x(t, { value: n }) {
  n && h(t, { value: n });
}
function S(t, { value: n }) {
  n && t.removeChild(t.mirror);
}
const l = {
  beforeMount: y,
  mounted: W,
  updated: x,
  unmounted: S
};
export {
  l as PendoInputAutowidth,
  u as copyStyles,
  l as default,
  f as formatWidthProp,
  h as setInputWidth
};
//# sourceMappingURL=pendo-input-autowidth.js.map
